<template>
  <div class="playerWrap">
    <div class="poster" v-show="poster">
      <div class="optionsBg"></div>
      <span v-if="this.$route.query.type == 'live'" class="live_status"
        :style="{ background: this.videoinfo.lState == 1 ? '#0f9c00' : this.videoinfo.lState == 2 ? '#4C9BC7' : this.videoinfo.lState == 3 ? '#FF7720' : this.videoinfo.lState == 0 ? '#B40000' : '', }">
        {{ videoinfo.lState == 0 ? '未开始' : videoinfo.lState == 1 ? '正在直播' : videoinfo.lState == 2 ? '直播结束' : videoinfo.lState == 3 ? '直播回顾' : '' }}
      </span>
      <img class="bg" v-bind:style="{ height: `${videoHeight}px` }" :src="posterUrl" alt="">
      <img class="play" @click='playVideo' src="../../assets/images/play.png" alt="">
    </div>
    <div class="prism-player" id="J_prismPlayer" v-show="!poster" style="z-index: 1"
      v-bind:style="{ height: `${videoHeight}px` }"></div>

  </div>
</template>
<script>
import Chimee from "chimee";
import weui from "weui.js";
import bus from "../../components/bus/index";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
// import ChimeeMobilePlayer from 'chimee-mobile-player' //移动端
// import chimeePluginControlbar from 'chimee-plugin-controlbar';
// Chimee.install(chimeePluginControlbar);

export default {
  data() {
    return {
      videoHeight: null,
      isQuestion: false,
      chimee: null,
      poster: true,
      status: "",
      // isShow:false,
      list: [],
      active: 1,
      // answer:[],
      // rightanswer:[],
      dialog: "",
      ra_wxUser: null,
      last: 0,
      pageType: "",

      // posterUrl:null,
    };
  },
  props: {
    videoinfo: {
      type: Object,
    },
    isCanPlay: {
      type: Boolean,
    },
  },
  async mounted() {
    this.ra_wxUser = await loginService.getLoginUser();
    // console.log('视频数据',this.videoinfo)
    let docWidth = document.documentElement.clientWidth;
    let videoHeight = (docWidth * 9) / 16;
    this.videoHeight = videoHeight;
    // console.log('视频mounted',this.videoinfo.vViewUrl)
    this.pageType = this.$route.query.type;
    this.$nextTick(() => {
      this.chimeeConfig();
    });
  },
  methods: {
    async playVideo() {
      //托拉斯特需求：需要判断用户是否登录=> 校验星星是否有值
      if (this.valideEmail() == false) {
        this.toast('请完善注册信息');
        this.$router.push({
          path: "/userInfor"
        });
        return;
      }

      if (this.isCharge) {
        // this.topTips('请先购买课程');
        let fees = "";
        if (this.$route.query.type == "video") {
          fees = this.videoinfo.vFees;
        } else {
          fees = this.videoinfo.lFees;
        }
        let  message = `请先购买课程\n 课程价格${fees}元`
        // 直播回顾、视频、专栏 这三种情况需要给出提示视频有限期限
        if((this.videoinfo.lState == 3 || this.$route.query.type == "video"|| this.$route.query.type == "column") && fees!=0) {
          message = `请先购买课程\n 课程价格${fees}元\n 购买后有效期半年可看`
        }
        this.$dialog
          .confirm({
            title: "提示",
            message: message,
          })
          .then(() => {
            // on confirm
            this.$emit("watchPay");
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      this.ra_wxUser = await loginService.getLoginUser();

      if (this.$route.query.type == "live") {
        if (this.videoinfo.lState == 1 || this.videoinfo.lState == 3) {
          if(this.isCanPlay) {
            this.poster = false;
            this.chimee.play();
          } else {
            this.topTips('可播放时间为:'+ this.videoinfo.lOpenBeginTime+'至' + this.videoinfo.lOpenEndTime);
            return false;
          }
        } else {
          this.topTips("直播未开始或已结束");
          return;
        }
      } else {
        if(this.isCanPlay) {
          this.poster = false;
          this.chimee.play();
        } else {
          this.topTips('可播放时间为:'+ this.videoinfo.vOpenBeginTime+'至' + this.videoinfo.vOpenEndTime);
          return false;
        }
      }

      if (this.$route.query.type == "video") {
        this.$postHttp(AppSetting.baseUrl + "/video/count", {
          vid: this.$route.query.videoId,
        }).then((res) => {
          if (res.data.code == 0) {
          }
        });
      }
    },
    chimeeConfig() {
      // let duration = this.videoinfo.vSeeTime * 60;
      console.log("视频info", this.videoinfo);
      this.chimee = new Aliplayer({
        id: "J_prismPlayer",
        width: "100vw",
        //支持播放地址播放,此播放优先级最高
        source: this.videoinfo.vViewUrl,
        isLive:
          this.$route.query.type == "video"
            ? false
            : this.videoinfo.lState == 3
              ? false
              : true,
        // components: [{
        //   name: 'PreviewVodComponent',
        //   type: AliPlayerComponent.PreviewVodComponent,
        //   args: [duration, '', '开通会员看完整视频']
        // }]
      },
        () => {
          console.log(this.videoinfo.showWatermark)
          if (this.videoinfo.showWatermark) {
            console.log('播放器创建成功', this.ra_wxUser);
            // 创建水印元素
            var watermark = document.createElement('div');
            watermark.textContent = this.ra_wxUser.uPhone ? this.ra_wxUser.uPhone : this.ra_wxUser.uId; // 水印文本
            watermark.style.position = 'absolute';
            watermark.style.top = '10px';
            watermark.style.right = '10px';
            watermark.style.color = 'black';
            watermark.style.opacity = '0.5'; // 设置透明度为 50%
            watermark.style.fontSize = '12px';
            watermark.style.zIndex = 999; // 确保水印显示在最上层

            // 获取播放器容器
            var playerContainer = document.getElementById('J_prismPlayer');
            playerContainer.appendChild(watermark);

            // 初始化水印移动参数
            let xSpeed = 1; // x 轴移动速度
            let ySpeed = 1; // y 轴移动速度
            let currentX = parseInt(watermark.style.left) || 0;
            let currentY = parseInt(watermark.style.top) || 0;

            // 定时更新水印位置
            let moveInterval;
            function startMoving() {
              moveInterval = setInterval(() => {
                // 获取播放器容器的宽度和高度
                const containerWidth = playerContainer.offsetWidth;
                const containerHeight = playerContainer.offsetHeight;
                // 获取水印元素的宽度和高度
                const watermarkWidth = watermark.offsetWidth;
                const watermarkHeight = watermark.offsetHeight;

                // 更新位置
                currentX += xSpeed;
                currentY += ySpeed;

                // 检查边界并改变方向
                if (currentX + watermarkWidth > containerWidth || currentX < 0) {
                  xSpeed = -xSpeed;
                }
                if (currentY + watermarkHeight > containerHeight || currentY < 0) {
                  ySpeed = -ySpeed;
                }

                // 更新水印的位置
                watermark.style.left = currentX + 'px';
                watermark.style.top = currentY + 'px';
              }, 50);
            }

            function stopMoving() {
              clearInterval(moveInterval);
            }

            // 随机生成 15 - 20 秒的展示时间
            const showTime = Math.floor(Math.random() * (20 - 15 + 1) + 15) * 1000;
            const hideTime = 30 * 1000;

            function showWatermark() {
              watermark.style.display = 'block';
              startMoving();
              setTimeout(() => {
                hideWatermark();
              }, showTime);
            }

            function hideWatermark() {
              watermark.style.display = 'none';
              stopMoving();
              setTimeout(() => {
                showWatermark();
              }, hideTime);
            }

            // 开始循环
            showWatermark();
            // // 处理全屏事件，确保全屏时水印也正常显示
          this.chimee.on('fullscreenchange',  ()=> {
            if (this.chimee.isFullscreen()) {
                // 全屏时调整水印样式
                watermark.style.position = 'fixed';
            } else {
                // 退出全屏时恢复水印样式
                watermark.style.position = 'absolute';
            }
          })

          }



          
        }
      );

      // console.log(this.chimee.$level)
      const originLevel = this.$level;
      // this.$bumpToTop();
      this.$level = originLevel;
      this.chimee.on("beforeSeek", () => {
        return false;
      });
      bus.$on("isstop", (val) => {
        if (val == "stop") {
          this.poster = true;
          this.chimee.pause();
        }
      });

      this.chimee.on("ready", () => {
        this.chimee.pause();
      });
      this.chimee.on("ended", () => {
        //将结束的状态传递给父级
        this.chimee.pause();
        this.poster = true;
        let duration = this.chimee.getDuration() - this.chimee.getCurrentTime();
        if (duration == 0) {
          this.$emit("ok", "success");
        }
      });
    },
  },
  computed: {
    isCharge() {
      let status = false; // true 用户需要订阅  false 用户不需要订阅或已经订阅

      let curPrice = this.videoinfo.lFees;

      if (this.pageType == "live") {
        if (!this.videoinfo.buyed) {
          status = true;
        }
      } else {
        if (!this.videoinfo.buyed) {
          status = true;
        }
      }

      return status;
    },
    posterUrl() {
      // let  url = this.videoinfo.vPicUrl||this.videoinfo.lPicUrl;
      // console.log(url)
      let url;
      if (this.$route.query.type == "video") {
        url = this.videoinfo.vPicUrl
          ? this.videoinfo.vPicUrl
          : this.videoinfo.vViewUrl +
          "?x-oss-process=video/snapshot,t_5000,f_jpg,w_800,h_600,m_fast";
      } else {
        console.log();
        url = this.videoinfo.lPicUrl;
      }

      return url;
    },
  },
};
</script>
<style scoped lang="scss">
.playerWrap {
  position: relative;
  width: 100vw;
  overflow: hidden;
}

.mask {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  >div {
    width: 5rem;
    height: 3rem;
    position: fixed;
    z-index: 5000;
    max-width: 300px;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #fff;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;

    div {
      padding: 0px;
      padding-left: 0.63rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      text-align: left;
      height: 0.66rem;
      padding-top: 0.36rem;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: left;
    }
  }
}

.bgoptons {
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0px;
  bottom: 0px;
  z-index: 1000 !important;

  div {
    width: 5rem;
    height: 5rem;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    margin-top: 3.54rem;
    margin-left: 1.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 3000 !important;

    >ul {
      height: 3.7rem;
      width: 5rem;
      overflow-y: scroll;
      padding: 0.22rem 0.19rem 0px;
      box-sizing: border-box;
    }
  }

  .outline {
    padding: 0.1rem;
    display: flex;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1px solid #0e94ff;
    width: 0.32rem;
    height: 0.32rem;
    position: relative;
    margin-right: 0.1rem;
  }

  i {
    position: absolute;
    left: 0.06rem;
    top: 0.06rem;
    border-radius: 50%;
    display: inline-block;
    width: 0.17rem;
    height: 0.17rem;
    /*border: 1px solid #949393;*/
    vertical-align: middle;
    margin-right: 0.1rem;
  }

  .active {
    background: #0e94ff;
    /*padding: 0.1rem;*/
    /*box-sizing: border-box;*/
    display: inline-block;
  }

  &.active {
    i {
      &:after {
        content: "·";
        position: absolute;
        width: 60%;
        height: 60%;
        background-color: #f39800;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .title {
    font-size: 0.32rem;
    font-family: 微软雅黑;
    font-weight: bold;
    color: #333333;

    .title_item {
      font-size: 0.28rem;
      font-weight: 500;
      padding-left: 0.37rem;
      box-sizing: border-box;
    }
  }

  .sub_btn {
    width: 1.8rem;
    height: 0.6rem;
    margin: auto;
    border: 1px solid rgba(230, 230, 230, 1);
    background: linear-gradient(0deg,
        rgba(0, 127, 255, 1) 0%,
        rgba(33, 175, 255, 1) 100%);
    border-radius: 5px;
    color: #ffffff;
    outline: none;
  }
}

#J_prismPlayer {
  width: 100%;
}

video {
  width: 100%;
  z-index: 1;
}

container {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

.poster {
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.optionsBg {
  position: absolute;
  width: 100%;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
}

.poster .live_status {
  position: absolute;
  color: #ffffff;
  display: inline-block;
  right: 0.22rem;
  top: 0.22rem;
  width: 1.2rem;
  height: 0.46rem;
  -webkit-border-radius: 23px;
  -moz-border-radius: 23px;
  border-radius: 23px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.22rem;
}

.poster .bg {
  width: 100%;
  display: block;
}

.poster .play {
  width: 1.2rem;
  position: absolute;
  top: 50%;
  margin-left: -0.6rem;
  margin-top: -0.6rem;
  left: 50%;
}

video {
  width: 100%;
  height: 100%;
  display: block;
  background-color: #000;
}

video:focus,
video:active {
  outline: none;
}</style>



// WEBPACK FOOTER //
// src/components/container/player.vue